function showLastMinuteModal(){
	var lmm = document.getElementById('last-minute-modal-html');
	if(lmm){
		GIG.Modal.create(lmm.innerHTML);
	}
}

window.showLastMinuteModal = showLastMinuteModal
